import { TLatLng } from "../../types/map";
import { localStorageKeys } from "../../utils/localStorageItems";
import { BingImageryMetaRequest, BingLocationAddress } from "../types/Map";
import { LegacyReportListingPayload } from "../types/Report";

type TAppEnv = "be-local" | "dev" | "qa" | "uat" | "prod";

export const APP_ENV: TAppEnv =
  window.location.hostname === "localhost" && window.location.port === "8000"
    ? "be-local"
    : window.location.hostname.includes("load-balancer-dev") ||
        window.location.hostname.includes("localhost") ||
        window.location.hostname.includes("ngrok-free.app")
      ? "dev"
      : window.location.hostname.includes("load-balancer-qa")
        ? "qa"
        : window.location.hostname.includes("load-balancer-uat")
          ? "uat"
          : "prod"; // PROD

let _API_SERVER_URL = "";
let _VM_API_SERVER_URL = "";
let _VM_ENV = "staging";

// old conditions for BE API endpoints
// switch (APP_ENV as TAppEnv) {
//   case "be-local":
//     _API_SERVER_URL = "http://localhost:8000";
//     break;
//   case "dev":
//     _API_SERVER_URL =
//       "https://ecs-load-balancer-dev-1752132226.us-west-2.elb.amazonaws.com";
//     break;
//   case "qa":
//     _API_SERVER_URL =
//       "https://ecs-load-balancer-qa-669565674.us-west-2.elb.amazonaws.com";
//     break;
//   case "uat":
//     _API_SERVER_URL =
//       "https://ecs-load-balancer-uat-2145024377.us-west-2.elb.amazonaws.com";
//     break;
//   case "prod":
//   default:
//     _API_SERVER_URL = "https://app.fleettrack.com";
//     break;
// }

// new conditions for BE API endpoints
if (
  !window.location.origin.includes("localhost:8000") &&
  (window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("ngrok-free.app"))
) {
  // dev environment used explicitly for localhost and ngrok
  _API_SERVER_URL =
    //"https://ecs-load-balancer-dev-1752132226.us-west-2.elb.amazonaws.com"; // dev
   "https://ecs-load-balancer-qa-669565674.us-west-2.elb.amazonaws.com"; // qa
  // "https://uat.fleettrack.com"; // uat
  _VM_API_SERVER_URL = "https://api.visionmaxfleet.com";
  // enable the code below to temporarily use production environment in development
  if (false) {
    _API_SERVER_URL = "https://app.fleettrack.com";
    _VM_API_SERVER_URL = "https://api.visionmaxfleet.com";
    _VM_ENV = "prod";
  }
} else {
  // for all other environments the following ensure that
  // the app refers to the same domain as the one it is running on
  _API_SERVER_URL = window.location.origin;

  // for VisionMax use appropriate environments as below...
  if (_API_SERVER_URL.includes("app.fleettrack.com")) {
    // production
    _VM_API_SERVER_URL = "https://api.visionmaxfleet.com";
    _VM_ENV = "prod";
  } else {
    // all non-production environments
    _VM_API_SERVER_URL = "https://api.visionmaxfleet.com";
    _VM_ENV = "staging";
  }
}

// temporarily override API_SERVER_URL from localStorage
const lsApiServer = localStorage.getItem(localStorageKeys.TEMP_API_SERVER);
if (!!lsApiServer) {
  _API_SERVER_URL = lsApiServer;
}

export const API_SERVER_URL = process.env.REACT_APP_BACKEND_URL || _API_SERVER_URL;
export const API_VERSION_SUFFIX = "/api/v1";

// 'dev' | 'qa' | 'uat' | 'prod' based on _API_SERVER_URL value
export const APP_APIS_ENV =
  API_SERVER_URL.includes("localhost") ||
  API_SERVER_URL.includes("ngrok-free.app")
    ? "dev"
    : API_SERVER_URL.includes("ecs-load-balancer-dev-")
      ? "dev"
      : API_SERVER_URL.includes("ecs-load-balancer-qa-")
        ? "qa"
        : API_SERVER_URL.includes("ecs-load-balancer-uat-")
          ? "uat"
          : API_SERVER_URL.includes("app.fleettrack.com")
            ? "prod"
            : "dev";

// the following constants are deprecated as now we are using API keys received from the backend
// (keys `VISIONMAX_BASE_URL` and `VISIONMAX_X_API_KEY` under `config` object in login response)
// ----------------------------------------------------------
// export const VM_ENV = _VM_ENV;
// export const VM_API_SERVER_URL = _VM_API_SERVER_URL;
export const VM_API_VERSION_SUFFIX = "/V2";

export const API_ENDPOINTS = {
  // onboarding
  LOGIN: `/legacy${API_VERSION_SUFFIX}/login/`,
  LOGIN_SSO_CREDS: `/legacy${API_VERSION_SUFFIX}/login-sso-creds/`,
  LOGIN_SSO_VERIFY: `/legacy${API_VERSION_SUFFIX}/azuresso-login/`,
  VERIFY_EMAIL_OTP: `/legacy${API_VERSION_SUFFIX}/verify-email-otp/`,
  RESEND_EMAIL_OTP: `/legacy${API_VERSION_SUFFIX}/resend-email-otp/`,
  FORGOT_PASSWORD: `/legacy${API_VERSION_SUFFIX}/forgot-password/`,
  RESEND_FORGOT_PASSWORD: `/legacy${API_VERSION_SUFFIX}/resend-forgot-password/`,
  FORGOT_PASSWORD_VERIFY_OTP: `/legacy${API_VERSION_SUFFIX}/forgot-password-verify-otp/`,

  // invite users & role permissions
  ORGANIZATION: {
    SHOW_INVITE_USER: (invitationToken: string) =>
      `/service${API_VERSION_SUFFIX}/show-invite-user/${invitationToken}/`,
    ROLES_PERMISSIONS: (accountid: string) =>
      `/legacy${API_VERSION_SUFFIX}/account-roles/${accountid}/`,
    INVITE_USER: `/service${API_VERSION_SUFFIX}/invite-user/`,
    RESEND_INVITE: `/service${API_VERSION_SUFFIX}/resend-invite/`,
    ONBOARD_INVITED_USER: `/service${API_VERSION_SUFFIX}/onboard-invited-user/`,
    ACCOUNT_ACCESS_POLICY: `/service${API_VERSION_SUFFIX}/account-access-policy/`,
    USER_FT1_ACCESS: `/service${API_VERSION_SUFFIX}/user-ft1-access/`,
  },

  // user profile
  USERS: {
    CHANGE_PASSWORD: `/legacy${API_VERSION_SUFFIX}/change-password/`,
    NOTIFICATION_PREFS: `/service${API_VERSION_SUFFIX}/notification-preference/`,
    LOGOUT: `/legacy${API_VERSION_SUFFIX}/logout/`,
  },

  // [outgoing] get url for the old FT 1.0 app
  FT1_0_LINK: `/legacy${API_VERSION_SUFFIX}/get-old-version-redirection-url/`,

  // [incoming] get authentication details when coming back to FT 2.0 from FT 1.0
  FT2_0_AUTH: `/legacy${API_VERSION_SUFFIX}/application-switch-login/`,

  // admins under organization/account
  ADMINS: {
    ORGANIZATION_USERS: `/legacy${API_VERSION_SUFFIX}/user/`,
    ORGANIZATION_USERS_FILTERABLE: `/legacy${API_VERSION_SUFFIX}/user/get-user-ids/`,
    SINGLE_ORGANIZATION_USER: (account_id: string, user_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/single-user/${account_id}/${user_id}/`,
    DELETE_ORGANIZATION_USER: (email: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-user/${email}/`,
    EDIT_ORGANIZATION_USER: `/legacy${API_VERSION_SUFFIX}/edit-user/`,

    ROLES: `/legacy${API_VERSION_SUFFIX}/role/`,
    SYSTEM_ROLES: `/legacy${API_VERSION_SUFFIX}/role/system-roles/`,
    SINGLE_ROLE: `/legacy${API_VERSION_SUFFIX}/role/single-role/`,
    CLONE_ROLE: `/legacy${API_VERSION_SUFFIX}/clone-role/`,
    EDIT_ROLE: `/legacy${API_VERSION_SUFFIX}/role/patch-role/`,
    EDIT_USER_ACL: `/legacy${API_VERSION_SUFFIX}/user-acl/`,
    DELETE_ROLE: (account_id: string, role_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-role/${account_id}/${role_id}/`,
    ROLE_ACL_CATEGORY: `/acl${API_VERSION_SUFFIX}/category/`,
    CATEGORY_ACL: `/acl${API_VERSION_SUFFIX}/`,
    ROLE_ACL: (account_id: string, role_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/role-acl-list/${account_id}/${role_id}/`,
    CREATE_ROLE_ACL: `/legacy${API_VERSION_SUFFIX}/role-acl/`,
    EDIT_ROLE_ACL: `/legacy${API_VERSION_SUFFIX}/role-acl/patch-acl-role/`,
    ADD_USERS_TO_ROLE: `/legacy${API_VERSION_SUFFIX}/role/add-users/`,
    UPLOAD_CUSTOM_ASSET_ICON: `bulk-upload${API_VERSION_SUFFIX}/asset-icons/upload/`,
    GET_CUSTOM_IMAGES: `bulk-upload${API_VERSION_SUFFIX}/asset-icons/list/`,
    GET_STANDARD_ICONS: `bulk-upload${API_VERSION_SUFFIX}/asset-icons/list/`,
    ORGANIZATION_VEHICLES: `/legacy${API_VERSION_SUFFIX}/device/`,
    UNIQUE_ID_VALIDATIONS: `/legacy${API_VERSION_SUFFIX}/device/validate-unique-id/`,
    ORGANIZATION_VEHICLES_FILTERABLE: `/legacy${API_VERSION_SUFFIX}/device/get-asset-ids/`,
    ORGANIZATION_VEHICLES_EVENTS: (account_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/account-vehicle-events/${account_id}/`,
    SINGLE_ORGANIZATION_VEHICLE: `/legacy${API_VERSION_SUFFIX}/device/single-device/`,
    DELETE_ORGANIZATION_VEHICLE: (account_id: string, device_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-device/${account_id}/${device_id}/`,
    EDIT_ORGANIZATION_VEHICLE: `/legacy${API_VERSION_SUFFIX}/device/patch-device/`,
    EDIT_ORGANIZATION_VEHICLE_IMAGE: `/legacy${API_VERSION_SUFFIX}/device/update-image/`,
    ALL_ASSET_LOCATIONS: `/legacy${API_VERSION_SUFFIX}/device/get-location/`,
    VEHICLE_RECORDER_STATUS: (account_id: string, device_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/device/recorder-status/?account_id=${account_id}&device_id=${device_id}`,
    VEHICLE_RECORDER_MEDIA_TOKEN: (account_id: string, device_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/device/connect-media/?account_id=${account_id}&device_id=${device_id}`,
    VEHICLE_DECODE_VIN: (asset_vin: string) =>
      `https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${asset_vin}?format=json`,
    VEHICLE_ADD_DEVICE_ZIPTIE: `/legacy${API_VERSION_SUFFIX}/device-zip-tie/`,
    VEHICLE_DEVICE_ZIPTIE: (ziptie_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/device-zip-tie/${ziptie_id}/`,
    VEHICLE_GET_DEVICE_ZIPTIE: (device_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/device-zip-tie/?device_id=${device_id}`,

    VEHICLE_MAP_DATA: (
      account_id: string,
      device_id: string,
      start_timestamp: number,
      end_timestamp: number,
      sort_time: "desc" | "asc"
    ) =>
      `/legacy${API_VERSION_SUFFIX}/vehicle-map-data/${account_id}/${device_id}/${start_timestamp}/${end_timestamp}/?sort_time=${sort_time}`,
    
    VEHICLE_MAP_DATA_MULTI:(
      start_timestamp: number,
      end_timestamp: number,
      deviceIds: string[],
      sort_time: "desc" | "asc" = "asc"
    ) => `legacy${API_VERSION_SUFFIX}/vehicle-map-data/multi/${start_timestamp}/${end_timestamp}/?device_ids=${deviceIds.join(",")}&sort_time=${sort_time}`,
    VEHICLE_MAP_DATA_MULTI_EVENT_COUNT: `/legacy${API_VERSION_SUFFIX}/vehicle-map-data/multi/event-count/`,

    ORGANIZATION_DRIVERS: `/legacy${API_VERSION_SUFFIX}/driver/`,
    SINGLE_ORGANIZATION_DRIVER: `/legacy${API_VERSION_SUFFIX}/driver/single-driver/`,
    DELETE_ORGANIZATION_DRIVER: (account_id: string, driver_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-driver/${account_id}/${driver_id}/`,
    EDIT_ORGANIZATION_DRIVER: `/legacy${API_VERSION_SUFFIX}/driver/patch-driver/`,
    EDIT_ORGANIZATION_DRIVER_IMAGE: `/legacy${API_VERSION_SUFFIX}/driver/update-image/`,

    ORGANIZATION_GROUPS: `/legacy${API_VERSION_SUFFIX}/group/`,
    SINGLE_ORGANIZATION_GROUP: (group_id: number) =>
      `/legacy${API_VERSION_SUFFIX}/group/single-group/`, // TODO: needs fixing
    SINGLE_ORGANIZATION_GROUP_VEHICLES: (
      account_id: string,
      group_id: string
    ) =>
      `/legacy${API_VERSION_SUFFIX}/group/vehicles/?account_id=${account_id}&group_id=${group_id}`,
    EDIT_ORGANIZATION_GROUP: `/legacy${API_VERSION_SUFFIX}/group/patch-group/`, // TODO: needs fixing
    EDIT_ORGANIZATION_GROUP_VEHICLES: `/legacy${API_VERSION_SUFFIX}/group/update-vehicles/`,
    SINGLE_ORGANIZATION_GROUP_USERS: (account_id: string, group_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/group/users/?account_id=${account_id}&group_id=${group_id}`,
    EDIT_ORGANIZATION_GROUP_USERS: `/legacy${API_VERSION_SUFFIX}/group/update-users/`,
    DELETE_ORGANIZATION_GROUP: (accountid: string, groupid: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-group/${accountid}/${groupid}/`,

    ORG_GH_LIST_GROUPS: `/service${API_VERSION_SUFFIX}/device-group-hierarchy/hierarchy/`,
    ORG_GH_CREATE_GROUP: `/service${API_VERSION_SUFFIX}/device-group-hierarchy/`,
    ORG_GH_UPDATE_DELETE_GROUP: (group_id: string) =>
      `/service${API_VERSION_SUFFIX}/device-group-hierarchy/${group_id}/`,

    EDIT_ORGANIZATION_ACCOUNT: (account_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/account/${account_id}/`,

    ORGANIZATION_FLEETTAGS: `/legacy${API_VERSION_SUFFIX}/entity/`,
    SINGLE_ORGANIZATION_FLEETTAG: `/legacy${API_VERSION_SUFFIX}/entity/single-entity/`,
    EDIT_ORGANIZATION_FLEETTAG: `/legacy${API_VERSION_SUFFIX}/entity/patch-entity/`,
    DELETE_ORGANIZATION_FLEETTAG: (accountid: string, entityid: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-entity/${accountid}/${entityid}/`,

    ORGANIZATION_GEOZONES: `/legacy${API_VERSION_SUFFIX}/geozone/`,
    SINGLE_ORGANIZATION_GEOZONE: `/legacy${API_VERSION_SUFFIX}/geozone/single-geozone/`,
    EDIT_ORGANIZATION_GEOZONE: `/legacy${API_VERSION_SUFFIX}/geozone/patch-geozone/`,
    DELETE_ORGANIZATION_GEOZONE: (accountid: string, geozoneid: string) =>
      `/legacy${API_VERSION_SUFFIX}/delete-geozone/${accountid}/${geozoneid}/`,

    ORGANIZATION_GEOZONE_CATEGORIES: `/legacy${API_VERSION_SUFFIX}/geozone-category/`,
    SINGLE_ORGANIZATION_GEOZONE_CATEGORY: (geozonecategoryid: string) =>
      `/legacy${API_VERSION_SUFFIX}/geozone-category/${geozonecategoryid}/`,
    CREATE_ORGANIZATION_GEOZONE_CATEGORY: `/legacy${API_VERSION_SUFFIX}/geozone-category/`,
    EDIT_ORGANIZATION_GEOZONE_CATEGORY: `/legacy${API_VERSION_SUFFIX}/geozone-category/patch-category/`,
    DELETE_ORGANIZATION_GEOZONE_CATEGORIES: (geozonecategoryid: string) =>
      `/legacy${API_VERSION_SUFFIX}/geozone-category/delete-category/?categoryid=${geozonecategoryid}`,
    ASSIGN_GEOZONE_TO_GEOZONE_CATEGORY: `/legacy${API_VERSION_SUFFIX}/geozone-category/assign-geozone/`,
    ASSIGN_USER_TO_GEOZONE_CATEGORY: `/legacy${API_VERSION_SUFFIX}/geozone-category/assign-user/`,

    ORGANIZATION_VEHICLE_ALERTS: (accountid: string | null) =>
      `/legacy${API_VERSION_SUFFIX}/account-vehicle-alerts/${accountid}/`,
    SINGLE_ORGANIZATION_VEHICLE_ALERT: (
      accountid: string | null,
      deviceid: string | null
    ) =>
      `/legacy${API_VERSION_SUFFIX}/account-vehicle-alert/${accountid}/${deviceid}/`,

    ORGANIZATION_RULE_ALERT: `/legacy${API_VERSION_SUFFIX}/rule/`,
    SINGLE_ORGANIZATION_RULE_ALERT: (ruleid: string | null) =>
      `legacy${API_VERSION_SUFFIX}/rule/${ruleid}/`,
    EDIT_ORGANIZATION_RULE: (ruleid: string | undefined | null) =>
      `/legacy${API_VERSION_SUFFIX}/rule/${ruleid}/`,
    DELETE_ORGANIZATION_RULE: (accountid: string, ruleid: string) =>
      `/legacy${API_VERSION_SUFFIX}/rule/${ruleid}/`,

    SYSTEM_RULE_CRITERIA: `/legacy${API_VERSION_SUFFIX}/system-rule/`,
    NOTIFICATION_VARIABLE_LIST: `/legacy${API_VERSION_SUFFIX}/rule-notification-variable/`,

    SEND_MESSAGE: `/legacy${API_VERSION_SUFFIX}/send-sms/`,
    GET_ASSIGNED_DRIVER: (account_id: string, device_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/get-assigned-driver/${account_id}/${device_id}/`,
    ASSET_CAMERA_DETAILS: `/legacy${API_VERSION_SUFFIX}/device/single-device/`,
    ASSET_CAMERA_RECORDING: (
      device_id: string,
      timestamp: string | number,
      event_id: string | number
    ) =>
      `/legacy${API_VERSION_SUFFIX}/event-info/${device_id}/${timestamp}/${event_id}/`,
    ASSET_REQUEST_VIDEO: (
      device_id: string,
      timestamp: string | number,
      event_id: string | number
    ) =>
      `/legacy${API_VERSION_SUFFIX}/request-video/${device_id}/${timestamp}/${event_id}/`,

    ORGANIZATION_MAINTENANCE: `/legacy${API_VERSION_SUFFIX}/maintenance/`,
    SINGLE_ORGANIZATION_MAINTENANCE: (
      accountid: string | undefined | null,
      deviceid: string | undefined
    ) => `legacy${API_VERSION_SUFFIX}/maintenance/${deviceid}/`,
    EDIT_ORGANIZATION_MAINTENANCE: (deviceid: string | undefined | null) =>
      `/legacy${API_VERSION_SUFFIX}/maintenance/${deviceid}/`,

    ADD_MAINTENANCE_DETAILS: (deviceid: string | undefined) =>
      `/legacy${API_VERSION_SUFFIX}/maintenance/${deviceid}/add-maintenance-details/`,
    ASSET_MAINTENANCE_FAULT_CODES: (deviceid: string | undefined) =>
      `/legacy${API_VERSION_SUFFIX}/maintenance/${deviceid}/fault-code-info/`,

    ORGANIZATION_DOCUMENTS: `/document${API_VERSION_SUFFIX}/`,
    ORGANIZATION_SINGLE_DOCUMENT: (documentId: string) =>
      `/document${API_VERSION_SUFFIX}/${documentId}/`,

    // deprecated
    LEGACY_REPORTS: ({
      sub_report_type,
      accountid,
      device_id,
      driver_id,
      start_timestamp,
      end_timestamp,
    }: LegacyReportListingPayload) => {
      let apiEndpointSuffix = "";
      let entityId = "";

      switch (sub_report_type) {
        case "alert_by_status":
        case "asset_alert_detail":
        case "driver_events":
        case "driver_behaviour_report":
          entityId = `${driver_id}`;
          break;
        default:
          entityId = `${device_id}`;
          break;
      }

      switch (sub_report_type) {
        // case "assets_near_asset":

        case "battery_health":
          apiEndpointSuffix = `/battery-health`;
          break;

        case "coolant_temprature":
          apiEndpointSuffix = `/coolant-temp`;
          break;

        case "daily_distance_driven":
          apiEndpointSuffix = `/daily-distance-driven`;
          break;

        // case "digital_input_report":

        case "event_detail":
          apiEndpointSuffix = `/event-detail`;
          break;

        // case "event_detail_all":

        case "event_detail_speeding":
          apiEndpointSuffix = `/event-detail-speeding-events`;
          break;

        // case "geozone_report":

        // case "harsh_acceleration_report":

        // case "harsh_braking_report":

        // case "idle_report":

        // case "alert_by_status":

        // case "asset_alert_detail":

        // case "assets_near_categorized_geozone_groups":

        // case "assets_near_geozone":

        // case "exceeding_posted_speed":

        // case speeds_over:

        // case "driver_events":

        // case "driver_behaviour_report":

        // case "state_border_crossing_summary":

        // case "state_mileage_summary":

        default:
          return `/unknown`;
      }
      return `/legacy${API_VERSION_SUFFIX}/report${apiEndpointSuffix}/${accountid}/${entityId}/${start_timestamp}/${end_timestamp}/`;
    },

    VISIONMAX_GET_TOKEN: `/visionmax${API_VERSION_SUFFIX}/get-token/`,
    WHITE_LABEL_CONFIG: `/service${API_VERSION_SUFFIX}/look-and-feel/`,
  },
  SYSADMIN: {
    ENTERPRISE_ACCOUNTS: `/legacy${API_VERSION_SUFFIX}/account/`,
    SINGLE_ENTERPRISE_ACCOUNT: (account_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/account/${account_id}/`,
    SYSADMIN_LOGIN_AS_ACCOUNT_USER: `legacy${API_VERSION_SUFFIX}/sysadmin-login/`,
    AVAILABLE_CHILD_ACCOUNTS: (account_id: string) =>
      `/legacy${API_VERSION_SUFFIX}/account/available-child-accounts/?account_id=${account_id}`,
  },

  REPORTS: {
    REPORTS_UNDER_CATEGORY: `/report${API_VERSION_SUFFIX}/`,
    CREATE_CUSTOM_REPORT: `/report${API_VERSION_SUFFIX}/`,
    SPECIFIC_REPORT: (reportId: number) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/`,
    COPY_CUSTOM_REPORT: (reportId: number) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/copy-report/`,

    CATEGORY_FIELDS: `/report${API_VERSION_SUFFIX}/category-field/`,
    SPECIFIC_CATEGORY_FIELDS: (categoryId: number) =>
      `/report${API_VERSION_SUFFIX}/category-field/${categoryId}/`,

    SHARED_REPORT_INTERNALLY: `/report${API_VERSION_SUFFIX}/internal-share/`,
    SHARED_REPORT_VIA_EMAIL: `/report${API_VERSION_SUFFIX}/external-share/`,
    EDIT_SHARED_REPORT_VIA_EMAIL: (externalShareId?: number) =>
      `/report${API_VERSION_SUFFIX}/external-share/${externalShareId}/`,
    EXTERNAL_SHARE_LIST: `/report${API_VERSION_SUFFIX}/external-share-email/`,

    STANDARD_REPORT_ALL_FIELDS: (reportId: number) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/all-fields/`,
    RUN_REPORT: (reportId: string) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/run-report/`,
    RUN_CUSTOM_REPORT: (reportId: string) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/run-custom-report/`,

    REPORT_COLUMN_FILTER_DROPDOWN_VALUES: (reportId: number) =>
      `/report${API_VERSION_SUFFIX}/${reportId}/dropdown-values/`,
  },

  INCIDENTS:{
    INCIDENT_CONFIG: `/incident-review${API_VERSION_SUFFIX}/config/`,
    INCIDENT_LISTING: `/incident-review${API_VERSION_SUFFIX}/incidents/`,
    INCIDENT_LAYOUT: `/incident-review${API_VERSION_SUFFIX}/layout/`,
    INCIDENT_DETAIL: (recordid: string | number) =>
      `/incident-review${API_VERSION_SUFFIX}/incidents/${recordid}/detail/`,
    INCIDENT_DISPOSITION: `/incident-review${API_VERSION_SUFFIX}/incidents/disposition/`,
  },

  INCABCOACHING:{
    INCAB_CONFIG:`/incab-coaching${API_VERSION_SUFFIX}/config/`,
  },
  NOTIFICATIONS: {
    GET_NOTIFICATIONS: `/notification${API_VERSION_SUFFIX}/`,
    MARK_AS_READ: (notificationId: number) =>
      `/notification${API_VERSION_SUFFIX}/${notificationId}/mark-read/`,
    MARK_ALL_AS_READ: `/notification${API_VERSION_SUFFIX}/mark-all-as-read/`,
    NOTIFICATION_SUMMARY: `/notification${API_VERSION_SUFFIX}/summary/`,
    BUZZER_ALERTS: `/notification${API_VERSION_SUFFIX}/buzzer-alert/`,
    UPDATE_BUZZZER_ALERT_STATUS: (buzzerAlertId: number) =>
      `/notification${API_VERSION_SUFFIX}/buzzer-alert/${buzzerAlertId}/`,
  },

  BULK_UPLOAD: {
    BLANK_TEMPLATE: `/bulk-upload${API_VERSION_SUFFIX}/template/`,
    CREATE_BULK_UPLOAD_REQUEST: `/scheduler${API_VERSION_SUFFIX}/uploaded-file/`,
    RUN_PROCESS: `/scheduler${API_VERSION_SUFFIX}/`,
    PROCESS_STATUS: (processId: number) =>
      `/scheduler${API_VERSION_SUFFIX}/${processId}/`,
  },
  SCHEDULER: {
    PROCESS_STATUS: (processId: number) =>
      `/scheduler${API_VERSION_SUFFIX}/${processId}/`,
  },

  HELP: {
    FAQ_BY_CATEGORY: (category_name: string) =>
      `/help${API_VERSION_SUFFIX}/faq/?category__name=${category_name}`,
    ALL_ARTICLES: (page: number, page_size: number) =>
      `/help/api/v1/articles/?page=${page}&page_size=${page_size}`,
    ARTICLE_BY_SLUG: (slug: string) =>
      `/help/api/v1/articles/${encodeURIComponent(slug)}/`,
    ARTICLE_BY_ROUTE: (route: string) =>
      `/help/api/v1/articles/by-route/?route=${route}`,
    ARTICLE_SEARCH: (query: string) =>
      `/help/api/v1/articles/?search=${encodeURIComponent(query)}`,
  },

  CHAT: {
    GET_ALL_CHANNELS: `/chat${API_VERSION_SUFFIX}/?page_size=500`,
    SEARCH_USERS: `${API_VERSION_SUFFIX}/chat-user/`,
    CREATE_CHANNEL: `/chat${API_VERSION_SUFFIX}/`,
  },

  SMS: {
    GET_DRIVERS: `${API_VERSION_SUFFIX}/sms-user/`,
    GET_SMS: `/legacy${API_VERSION_SUFFIX}/sms/`,
    GET_UNREAD_COUNT: `${API_VERSION_SUFFIX}/sms-user/unread-count/`,
  },

  OVERVIEW: {
    DASHBOARDS: `/dashboard${API_VERSION_SUFFIX}/`,
    UPDATE_DELETE_DASHBOARD: (dashboardId: number) =>
      `/dashboard${API_VERSION_SUFFIX}/${dashboardId}/`,
    SET_DEFAULT_DASHBOARD: (dashboardId: number) =>
      `/dashboard${API_VERSION_SUFFIX}/${dashboardId}/set-default/`,
    CUSTOM_WIDGET: `/dashboard${API_VERSION_SUFFIX}/custom-widget/`,
    SINGLE_CUSTOM_WIDGET: (widgetId: number) =>
      `/dashboard${API_VERSION_SUFFIX}/custom-widget/${widgetId}/`,
  },

  GLOBAL_SEARCH: {
    SEARCH: `${API_VERSION_SUFFIX}/search/`,
  },

  CAMERA: {
    DEVICE_LISTING: `/visionmax${API_VERSION_SUFFIX}/list-devices/`,
    TRIP_SUMMARY: `/visionmax${API_VERSION_SUFFIX}/dashboard-trip-summary/`,
    EVENTS: (
      serial_number: string,
      start_time: string | number,
      end_time: string | number
    ) =>
      `/visionmax${API_VERSION_SUFFIX}/events/?serial_number=${serial_number}&start_time=${start_time}&end_time=${end_time}`,
    EVENT_DETAILS: (recordId: string) =>
      `/visionmax${API_VERSION_SUFFIX}/event-detail/?record_id=${recordId}`,
    FILE_RETRIEVAL_LISTING: `/visionmax${API_VERSION_SUFFIX}/file-retrieval/`,
    REQUEST_VIDEO: `/visionmax${API_VERSION_SUFFIX}/request-video/`,
    STATUS_CODES: `/visionmax${API_VERSION_SUFFIX}/status-codes/`,
  },

  HEATMAP: {
    CONFIG: `/service${API_VERSION_SUFFIX}/heat-map-config/`,
    EVENTS: `/legacy${API_VERSION_SUFFIX}/heat-map-events/`,
  },

  GENERIC_STATUS_CODE: `/legacy${API_VERSION_SUFFIX}/generic-status-code/`,
  ACCOUNT_STATUS_CODE_COLORS: `/legacy${API_VERSION_SUFFIX}/account-status-code-colors/`,

  CRASH_TRACK: {
    LISTING: `/legacy${API_VERSION_SUFFIX}/crash-track/`,
    ASSET_INFO: (assetId: string, timestamp: string | number) =>
      `/legacy${API_VERSION_SUFFIX}/crash-track/asset-info/?device_id=${assetId}&timestamp=${timestamp}`,
    INCLIDENT_INFO: (assetId: string, timestamp: string | number) =>
      `/legacy${API_VERSION_SUFFIX}/crash-track/incident-info/?device_id=${assetId}&timestamp=${timestamp}`,
    CHARTS_DATA: (assetId: string, timestamp: string | number) =>
      `/legacy${API_VERSION_SUFFIX}/crash-track/impact-detail/?device_id=${assetId}&timestamp=${timestamp}`,
    EVENT_REPORT: (assetId: string, timestamp: string | number) =>
      `/legacy${API_VERSION_SUFFIX}/crash-track/event-info/?device_id=${assetId}&timestamp=${timestamp}`,
  },
};

// use of bing APIs is deprecated, we have moved to google APIs (long back)
// thus, disabled these bing API endpoints to prevent use which could cause errors
// export const BINGMAPS_ENDPOINTS = {
//   AUTOSUGGEST: (query: string) =>
//     "https://dev.virtualearth.net/REST/v1/Autosuggest" +
//     `?query=${encodeURIComponent(query)}` +
//     // '&userLocation=47.668697,-122.376373,5' +
//     // '&includeEntityTypes=Business' +
//     `&key=${process.env.REACT_APP_BING_MAPS_API_KEY}`,

//   GEOCODE: (address: BingLocationAddress) => {
//     type TAddress = keyof typeof address;
//     return (
//       "https://dev.virtualearth.net/REST/v1/Locations?" +
//       Object.keys(address)
//         .map((key: string) => `${key}=${address[key as TAddress]}`)
//         .join("&") +
//       // `&userLocation={userLocation}&userIp={userIp}&usermapView={usermapView}&includeNeighborhood={includeNeighborhood}` +
//       `&maxResults=5` +
//       `&key=${process.env.REACT_APP_BING_MAPS_API_KEY}`
//     );
//   },

//   REVERSE_GEOCODE: (latLng: TLatLng) =>
//     `https://dev.virtualearth.net/REST/v1/Locations/${latLng.latitude},${latLng.longitude}` +
//     `?key=${process.env.REACT_APP_BING_MAPS_API_KEY}`,

//   IMAGERY_META: (params: BingImageryMetaRequest) =>
//     `https://dev.virtualearth.net/REST/v1/Imagery/MetaData/${params.imagerySet}/${params.latitude},${params.longitude}?key=${process.env.REACT_APP_BING_MAPS_API_KEY}`,
//   // `https://dev.virtualearth.net/REST/v1/Imagery/Map/Streetside/${lat},${lon}/90?mapSize=500,500&key=${process.env.REACT_APP_BING_MAPS_API_KEY}`

//   // not in use - using Google Maps instead, as Android does not support Bing Maps per client feedback
//   PLACE_URL: (lat: number, lng: number) =>
//     `https://bing.com/maps/default.aspx?cp=${lat}~${lng}`,
// };

export const GOOGLEMAPS_ENDPOINTS = {
  AUTOSUGGEST: (query: string) =>
    `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${query}&types=geocode&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,

  // source: https://stackoverflow.com/a/52692527/1268350
  STREETVIEW_META: (lat: number, lng: number) =>
    `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,

  STREETVIEW_IFRAME_EMBED: (lat: number, lng: number, timestamp: number) =>
    `https://www.google.com/maps/embed?pb=!4v${timestamp || ""}!6m8!1m7!1s${lat},${lng}!2m2!1d${lat}!2d${lng}!3f0!4f0!5f0.7820865974627469`,
  // `https://www.google.com/maps/embed/v1/streetview?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&location=${lat},${lng}`,

  SNAP_TO_ROAD: (
    gpsPoints: google.maps.LatLngLiteral[],
    interpolate: boolean
  ) =>
    `https://roads.googleapis.com/v1/snapToRoads?path=${gpsPoints.map((item) => `${item.lat},${item.lng}`).join("|")}&interpolate=${interpolate ? "true" : "false"}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,

  PLACE_URL: (lat: number, lng: number) =>
    `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`,

  IMAGERY_META: (lat: number, lng: number) =>
    `https://maps.googleapis.com/maps/api/streetview/metadata?location=${lat},${lng}&radius=50&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  REVERSE_GEOCODE: (latLng: TLatLng) =>
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng.latitude},${latLng.longitude}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
};

export const OPENWEATHER_ENDPOINTS = {
  WEATHER_FORECAST: (lat: number, lon: number, units: string) =>
    `https://api.weather.com/v3/wx/forecast/daily/7day?geocode=${lat},${lon}&language=en-US&format=json&units=${units}&apiKey=${process.env.REACT_APP_OPENWEATHER_API_KEY}`,
 // startDateTime/endDateTime must be yyyyMMdd'T'HHmmss'Z' (UTC) - see utils/weatherHistory.ts formatHodDateTime
  WEATHER_HISTORY: (lat: number, lon: number, startDateTime: string, endDateTime: string, units: string) =>
    `https://api.weather.com/v3/wx/hod/r1/direct?geocode=${lat},${lon}&startDateTime=${startDateTime}&endDateTime=${endDateTime}&format=json&units=${units}&apiKey=${process.env.REACT_APP_OPENWEATHER_API_KEY}`,
};

export const VM_ENDPOINTS = {
  GET_ALL_DEVICE_IDS: `${VM_API_VERSION_SUFFIX}/group/ListGroup`,
  GET_ALL_AVAILABLE_MODELS: `${VM_API_VERSION_SUFFIX}/devices/available-models`,
  GET_LIVEVIEW_URL: `${VM_API_VERSION_SUFFIX}/elastic/create-url/device/liveview`,
  DEVICE_DETAILS: `${VM_API_VERSION_SUFFIX}/devices`,
  GET_DATA_USAGE: `${VM_API_VERSION_SUFFIX}/ota/data-usage`,
  GROUPS: `${VM_API_VERSION_SUFFIX}/group/List`,
  DEVICE_HEALTH: `${VM_API_VERSION_SUFFIX}/devices/health`,
  DEVICE_HEALTH_SIMPLE: `${VM_API_VERSION_SUFFIX}/devices/healthReport`,
  FORMAT_SD_CARD: `${VM_API_VERSION_SUFFIX}/devices/FormatSdCardToDevice`,
  ICC_HISTORY: `${VM_API_VERSION_SUFFIX}/devices/GetDeviceIccHistory`,
  DEVICE_WAKEUP: `${VM_API_VERSION_SUFFIX}/devices/wakeup`,
  GENERAL_INFO: `${VM_API_VERSION_SUFFIX}/devices`,
  CAMERA_CONFIG: (cameraId: string) =>
    `${VM_API_VERSION_SUFFIX}/configuration/${cameraId}`,
  UPDATE_CONFIGURATION_SINGLE_DEVICE: `${VM_API_VERSION_SUFFIX}/configuration`,
  DIAGNOSE_DEVICE: `${VM_API_VERSION_SUFFIX}/devices/health/diagnostic/system`,
  LAST_PARKING_PHOTO: `${VM_API_VERSION_SUFFIX}/devices/GetLastParkingPhoto`,
  EVENT_DETAIL: (ticketId: string) =>
    `${VM_API_VERSION_SUFFIX}/event/detailV2?ticket=${ticketId}`,
  EVENT_GET_VIDEO_DETAIL: `${VM_API_VERSION_SUFFIX}/event/GetVideoDetail`,
  DOWNLOAD_EVENT_VIDEO: `${VM_API_VERSION_SUFFIX}/event/download`,
  DELETE_SD_CARD_FILE: `${VM_API_VERSION_SUFFIX}/event/DeleteCloudStorage`,
  DEVICE_STORAGE_LIST: (deviceId: string) =>
    `${VM_API_VERSION_SUFFIX}/devices/${deviceId}/storage-list`,
  GET_TIMELINE: `${VM_API_VERSION_SUFFIX}/devices/GetTimeline`,
  GET_EVENT_COMMENTS: (ticketId: string) =>
    `${VM_API_VERSION_SUFFIX}/event/comments-get?ticket=${ticketId}`,
  SUBMIT_EVENT_COMMENT: `${VM_API_VERSION_SUFFIX}/event/comments-sent`,
  TASK_STATUS: (taskId: string) =>
    `${VM_API_VERSION_SUFFIX}/event/taskResult/${taskId}`,

  // used mainly for polling to identify incoming voicecalls
  DASH_NOTIFY: `${VM_API_VERSION_SUFFIX}/dashboard/notify`,
  INCOMING_VOICECALL_ANSWER: (request_id: string) =>
    `${VM_API_VERSION_SUFFIX}/VoiceCall/pickup/${request_id}`,
  INCOMING_VOICECALL_DECLINE: (request_id: string) =>
    `${VM_API_VERSION_SUFFIX}/VoiceCall/decline/${request_id}`,
};
